/* eslint-disable no-unused-vars */
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";
import { TokenStorage } from "../../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const BinLocationService = {
  async getByName(name) {
    const requestScreenData = {
      url: "api/BinLocation",
      top: "1",
      filter: `Location eq '${name}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByCode(code) {
    const requestScreenData = {
      url: "api/BinLocation",
      top: "1",
      filter: `Code eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async save(mode, BinLocation) {
    var payload = BinLocation;
    var url = "api/BinLocation";

    if (mode == "create") {
      return await ApiService.post(
        url,
        payload,
        "String"
      );
    }
    else {
      return await ApiService.patch(url, BinLocation.Code, payload, "String");
    }
  },
  async getBinLocation(filter) {
    const requestScreenData = {
      url: "api/BinLocation",
      filter,
      top: 1
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getProductBinLocation(filter) {
    const requestScreenData = {
      url: "api/ProductLocationList",
      filter,
      top: 1
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { BinLocationService };
